import Signin from './components/Signin'
import SigninCallback from './components/SigninCallback'
import Signout from './components/Signout'

export default [
    {
        path: '/signin',
        component: Signin,
    },
    {
        path: '/callback',
        component: SigninCallback,
    },
    {
        path: '/signout',
        component: Signout,
    },
]
